/* Mobile/UX Enhancements v2 - Textil World 2026-05-01
   - Description "Read more" toggle on long descriptions (mobile only)
   - Always-visible search bar injected into header (all viewports)
   Vanilla JS, no dependencies, defer-loaded. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* ============================================================
     1. Always-visible search bar
     Injected into the header so users can search from any page
     without clicking the search icon first.
     ============================================================ */
  function injectSearchBar() {
    if (document.querySelector('.tw-search-inline')) return;

    var header = document.querySelector('.t4s-section-header__mid');
    if (!header) return;

    var form = document.createElement('form');
    form.className = 'tw-search-inline';
    form.action = '/search';
    form.method = 'get';
    form.role = 'search';
    form.setAttribute('aria-label', 'Wyszukaj na sklepie');
    form.innerHTML =
      '<input type="search" name="q" autocomplete="off" ' +
      'placeholder="Szukaj tkanin, kolorów, kodów VC..." ' +
      'aria-label="Wyszukaj produkty" class="tw-search-inline__input">' +
      '<input type="hidden" name="type" value="product">' +
      '<button type="submit" class="tw-search-inline__submit" aria-label="Wyszukaj">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
      '<path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>' +
      '</svg></button>';

    var container = document.createElement('div');
    container.className = 'tw-search-row';
    container.appendChild(form);

    header.parentNode.insertBefore(container, header.nextSibling);
  }

  /* ============================================================
     2. Description "Read more" toggle on long descriptions
     ============================================================ */
  var MAX_HEIGHT = 280;
  var MOBILE_BREAKPOINT = 749;

  function isMobile() { return window.innerWidth <= MOBILE_BREAKPOINT; }

  function setupAccordion(el) {
    if (el.classList.contains('tw-desc-init')) return;
    if (el.scrollHeight <= MAX_HEIGHT + 80) return;
    el.classList.add('tw-desc-init', 'tw-desc-collapsed');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tw-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="tw-desc-toggle__more">Czytaj więcej</span>' +
                    '<span class="tw-desc-toggle__less">Pokaż mniej</span>' +
                    '<svg class="tw-desc-toggle__icon" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    btn.addEventListener('click', function () {
      var expanded = el.classList.toggle('tw-desc-expanded');
      el.classList.toggle('tw-desc-collapsed', !expanded);
      btn.classList.toggle('is-expanded', expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    if (el.parentNode) el.parentNode.insertBefore(btn, el.nextSibling);
  }

  function initAccordions() {
    if (!isMobile()) return;
    var selectors = [
      '.t4s-product__description',
      '.product__description',
      '.product-tabs__panel .rte',
      '[data-product-description]'
    ];
    selectors.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      Array.prototype.forEach.call(els, setupAccordion);
    });
  }

  function init() {
    injectSearchBar();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-run after late content (lazy-loaded tabs etc.) */
  setTimeout(init, 1500);
})();
